export default (function () {
  return typeof window.APP_URL !== 'undefined' ? window.APP_URL : 'https://platform.storyteq.com';
});